var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppealBackArrow = function SvgAppealBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.472.303-1.96 1.96a1.793 1.793 0 0 0 0 2.475l1.96 1.959a.75.75 0 1 0 1.06-1.06l-1.39-1.391 9.126-.011a.75.75 0 1 0 0-1.5l-9.118.011 1.382-1.383a.75.75 0 0 0-1.06-1.06Z"
  })));
};
export default SvgAppealBackArrow;